// extracted by mini-css-extract-plugin
export default {"itemSportWrapper":"ListSports_itemSportWrapper__Rmldc","shortView":"ListSports_shortView__au7ht","activeSport":"ListSports_activeSport__Cs+nQ"};